export default "__VITE_ASSET__8KryCAtw__"